// frontend/src/app/bootSplashSignal.ts
// Winziges modul-skopiertes Signal "der Vorspann (BootSplash) ist durch".
//
// Warum: die In-App-Tour (Part 1) darf NICHT starten, solange der Vorspann noch
// ueber der App liegt (CRIT 3) — sonst rendert die Tour ihr Overlay unter dem
// Siegel und zeigt danach auf Anchor, die beim Vorspann-Start noch gar nicht
// gemountet waren. Der BootSplash verwaltet seinen Lebenszyklus komplett selbst
// (Session-Gate, Mindest-/Animationsdauer, Notbremse) und wird am Ende
// unmountet — es gibt kein React-Context-State, den die Tour lesen koennte.
// Dieses Modul ueberbrueckt das mit einem simplen Observable ohne Provider.
//
// Semantik:
//   - "done" ist ein Einbahn-Latch: einmal true, bleibt true (der Vorspann
//     laeuft pro Mount genau einmal).
//   - onBootSplashDone(cb): feuert cb sofort, wenn schon fertig, sonst beim
//     naechsten markBootSplashDone(). Gibt eine Unsubscribe-Funktion zurueck.

let splashDone = false;
const listeners = new Set<() => void>();

/** Wird vom BootSplash gerufen, sobald er nicht mehr sichtbar ist (inkl. des
 *  Web-Session-Skip-Falls, in dem er gar nicht erst erscheint). Idempotent. */
export function markBootSplashDone(): void {
  if (splashDone) return;
  splashDone = true;
  for (const cb of Array.from(listeners)) {
    try { cb(); } catch { /* ein Listener darf die anderen nicht mitreissen */ }
  }
  listeners.clear();
}

export function isBootSplashDone(): boolean {
  return splashDone;
}

/** Abonniert das "fertig"-Ereignis. Feuert sofort, wenn bereits fertig. */
export function onBootSplashDone(cb: () => void): () => void {
  if (splashDone) {
    try { cb(); } catch { /* ignore */ }
    return () => { /* no-op */ };
  }
  listeners.add(cb);
  return () => { listeners.delete(cb); };
}

// Nur fuer Tests: den Latch zuruecksetzen, damit Faelle unabhaengig laufen.
export function __resetBootSplashSignalForTests(): void {
  splashDone = false;
  listeners.clear();
}
